/**
 * Trainer host moderation via LMS LiveKit shim → Streaming Engine.
 */

import { livekitAuthService as authService } from "../utils/authService";

export type ModerationAction =
  | "mute"
  | "unmute"
  | "remove"
  | "admit"
  | "hold"
  | "promote"
  | "demote";

export type ModerateParticipantResult = {
  session_id: number;
  lms_session_id: string;
  room_name: string;
  identity: string;
  action: string;
  track_source: string;
  ok: boolean;
  provider_type?: string;
};

export type ModerateParticipantsBulkResult = {
  session_id: number;
  lms_session_id: string;
  room_name: string;
  action: string;
  track_source: string;
  ok: boolean;
  targeted: number;
  succeeded: number;
  failed: number;
  results?: Array<{ identity: string; ok: boolean; error?: string }>;
  provider_type?: string;
};

export async function moderateLiveParticipant(params: {
  sessionId: string | number;
  identity: string;
  action: ModerationAction;
  trackSource?: "microphone" | "camera" | "all";
}): Promise<ModerateParticipantResult> {
  // ---------------------------------------------------------------
  // step 1: POST host action to LMS LiveKit shim
  // ---------------------------------------------------------------
  const res = await authService.post(
    `/livekit/sessions/${params.sessionId}/participants/moderate`,
    {
      identity: params.identity,
      action: params.action,
      track_source: params.trackSource || "microphone",
    },
  );
  return res.data as ModerateParticipantResult;
}

/** Class-wide mute/unmute — one API call (scale). */
export async function moderateLiveParticipantsBulk(params: {
  sessionId: string | number;
  action: "mute" | "unmute";
  trackSource?: "microphone" | "camera" | "all";
  identities?: string[];
}): Promise<ModerateParticipantsBulkResult> {
  const res = await authService.post(
    `/livekit/sessions/${params.sessionId}/participants/moderate-bulk`,
    {
      action: params.action,
      track_source: params.trackSource || "microphone",
      ...(params.identities ? { identities: params.identities } : {}),
    },
  );
  return res.data as ModerateParticipantsBulkResult;
}
